import { CertIcon, ImageIcon } from './DimensionerIcons'
import ScanFileRow from './ScanFileRow'

interface Props {
    imageCount: number
    imagesDisabled: boolean
    certificateDisabled: boolean
    onDownloadImages: () => void
    onDownloadCertificate: () => void
}

const ScanFiles = ({imageCount, imagesDisabled, certificateDisabled, onDownloadImages, onDownloadCertificate}: Props) => (
    <div>
        <label className="text-uppercase d-block" style={{fontSize: 10, fontWeight: 600, letterSpacing: '.06em', color: '#A1A5B7', marginBottom: 6}}>Scan files</label>
        <div className="d-flex flex-column" style={{gap: 8}}>
            <ScanFileRow icon={<ImageIcon size={15}/>} label="Images" sub={imageCount ? `${imageCount} photos · PDF` : 'PDF'} onClick={onDownloadImages} disabled={imagesDisabled}/>
            <ScanFileRow icon={<CertIcon size={15}/>} label="Certificate" sub="Weight &amp; cube · PDF" onClick={onDownloadCertificate} disabled={certificateDisabled}/>
        </div>
    </div>
)

export default ScanFiles
